module.exports = __webpack_public_path__ + "media/icons/checkmark-white-in-purple-background-6df74b56.png";